import { urlRegExp } from 'schemas'
import yup from './yup'

export const speakerFormSchema = yup.object().shape({
  fullName: yup.string().label('Full Name').trimmedRequired('Full name is required'),
  email: yup.string().email().label('Email').required('Email is required'),
  websiteUrl: yup
    .string()
    .matches(urlRegExp, 'Website URL must be a valid URL')
    .label('Website url'),
  bio: yup.string().label('Bio'),
  position: yup.string().label('Position'),
  company: yup.string().label('Company')
})
